import React, { FC } from "react";

export const HealthContainer: FC = () => {
    return (
        <div>
            <div>
                <p>200</p>
                <span>Hello from Radio Silpo</span>
            </div>
        </div>
    );
};

export default HealthContainer;
